
import './App.css';
import { Provider } from "react-redux";
import { RouteConfig } from './RouteConfig';
import { store } from './store';
import { LanguageProvider } from './contexts/LanguageContext';
import './i18n'; // Initialize i18n


import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <Provider store={store}>
      <LanguageProvider>
        <HelmetProvider>
          <RouteConfig />
        </HelmetProvider>
      </LanguageProvider>
    </Provider>
  );
}

export default App;

